function getCcyByCountry(val) {
    let s = {ccy: 'EUR', symbol: '€'};
    if(val === 'US') { s = {ccy: 'USD', symbol: '$'} }
    else if(val === 'GB') { s = {ccy: 'GBP', symbol: '£'} }
    else if(val === 'CH') { s = {ccy: 'CHF', symbol: 'CHF'} }
    return s;
}

export { getCcyByCountry }